import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Contact from './components/Contact';
import Header from './components/Header';
import WhatsAppFloat from './components/WhatsAppFloat';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white">
      <Header isScrolled={isScrolled} />
      <main>
        <section id="home">
          <Hero />
        </section>
        <section id="about">
          <About />
        </section>
        <section id="services">
          <Services />
        </section>
        <section id="why-choose-us">
          <WhyChooseUs />
        </section>
        <section id="areas">
          <ServiceAreas />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>
      <WhatsAppFloat />
    </div>
  );
}